module.exports = __webpack_public_path__ + "static/media/article17.7798a15c.webp";